export const dayFirstDigitMaxValue = 3

// only applied if the first digit is equal to the max value
export const daySecondDigitMaxValue = 1

export const numberOfDigits = 2